/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import styled from 'styled-components';
import { Section, Tag as CarbonTag, Heading as CarbonHeading } from '@carbon/react';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  align-content: center;
  justify-content: center;

  padding: 0 40px 0 40px;
  height: 100%;
`;

export const Description = styled(Section)`
  margin-top: 10px;
`;

export const Tag = styled(CarbonTag)`
  margin-bottom: var(--cds-spacing-03);
  margin-left: 0;
  width: 100px;
`;

export const Heading = styled(CarbonHeading)`
  font-size: var(--cds-heading-04-font-size);
`;
